import React from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import {SideNavItem} from './SideNav.styled'

import {Icon} from '~/components/general/icon/Icon'
import {theme} from '~/styles/theme'

export type PartnerAdminNavSectionProps = {
  active: boolean
}

export const PartnerAdminNavSection: React.FC<PartnerAdminNavSectionProps> = ({
  active,
}) => {
  const {t} = useTranslation<string>()

  return (
    <>
      <Link
        to="/app/partner"
        data-tip={t('Partner Management')}
        data-for="sideNav">
        <SideNavItem active={active}>
          <Icon
            name="Partner"
            color={active ? undefined : theme.colors.grey.main}
          />
        </SideNavItem>
      </Link>
      <Link to="/app/staff" data-tip={t('Staff Management')} data-for="sideNav">
        <SideNavItem active={active}>
          <Icon
            name="StaffAdmin"
            color={active ? undefined : theme.colors.grey.main}
          />
        </SideNavItem>
      </Link>
      <Link
        to="/app/services"
        data-tip={t('Services Management')}
        data-for="sideNav">
        <SideNavItem active={active}>
          <Icon
            name="ServicesAdmin"
            color={active ? undefined : theme.colors.grey.main}
          />
        </SideNavItem>
      </Link>
      <Link to="/app/reports" data-tip={t('Reports')} data-for="sideNav">
        <SideNavItem active={active}>
          <Icon
            name="Reports"
            color={active ? undefined : theme.colors.grey.main}
          />
        </SideNavItem>
      </Link>
    </>
  )
}
